
import Vue from "vue";

import { checkVuelidateValidation } from "@/helpers/processValidation";
import RadioButtonGroup from "@/components/FormBuilder/Components/RadioButtonGroup.vue";
import { quoteMapState } from "@/store/modules/quote";
import { set } from "lodash";

export default Vue.extend({
  inheritAttrs: false,
  name: "HO210Fields",
  components: { RadioButtonGroup },
  props: {
    label: {
      type: String,
      required: false,
      default: ""
    },
    id: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      type: [Boolean, String, Number],
      required: false,
      default: false
    },
    validations: {
      type: Array,
      required: false,
      default: () => []
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      HO210Pro11: "",
      HO210Pro12: "",
      HO210Pro13: "",
      HO210Pro21: "",
      HO210Pro22: "",
      HO210Pro23: "",
      HO210Pro31: "",
      HO210Pro32: "",
      HO210Pro33: "",
      HO210Pro4: "",
      yesNoOptions: [
        { value: "1", label: "Yes" },
        { value: "2", label: "No" }
      ]
    };
  },
  mounted() {
    const valuesArray = [
      "HO210Pro11",
      "HO210Pro12",
      "HO210Pro13",
      "HO210Pro21",
      "HO210Pro22",
      "HO210Pro23",
      "HO210Pro31",
      "HO210Pro32",
      "HO210Pro33",
      "HO210Pro4"
    ];
    const endorsement = this.editing.endorsements.find((e: any) => {
      return e.formCode === "210";
    });
    if (endorsement && endorsement.values) {
      for (let value of valuesArray) {
        const endorsementValue = endorsement.values.find((val: any) => {
          return val.key == value;
        });
        if (endorsementValue) {
          set(this, value, endorsementValue.value);
        }
      }
    }
  },
  methods: {
    inputValueChanged($event: any, ref: string): void {
      set(this, ref, $event);
      const value = {
        value: $event,
        ref: ref
      };
      this.$emit("change", value);
    }
  },
  computed: {
    ...quoteMapState(["editing"]),
    validationResult(): {
      isValid: boolean;
      error: string;
    } {
      return checkVuelidateValidation(this.validations as any, this.value);
    }
  }
});
